// extracted by mini-css-extract-plugin
module.exports = {"helpFrame":"_c7b1c1f","body":"_d123d17"};